/* eslint-disable max-lines */
import { trpcNoAuth } from '@prishapolicy/shared/trpc';
import { BoxToggle, Button, CheckToggle, DropDownSelect, Form, showToast, TextInput } from '@prishapolicy/shared/ui';
import { useInsuranceForDoctorsFormType } from '@prishapolicy/w3/ui';
import { useFormikContext } from 'formik';
import * as Yup from 'yup';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { OptionsArray } from '@prishapolicy/backend-core/masters';

type MoreOffersFormInfo = {
  professionalIndemnityForDoctors: boolean | null;
  professionalIndemnityForMedicalSetup: boolean | null;
  motorInsurance: boolean | null;
  healthInsurance: boolean | null;
  homeInsurance: boolean | null;
  cyberInsurance: boolean | null;
  otherInsurance: boolean | null;

  selectedSpeciality: string | null;

  numberOfBeds: number | null;
  vehicleRegistrationNumber: string | null;

  typeOfHealth: boolean | null;
  sumInsured: number | null; //Health Sum Insured

  pincode: number | null;
  homeInsuranceSumInsured: number | null; //Home Sum Insured

  cyberInsuranceSumInsured: number | null; //Cyber Sum Insured

  typeOfOtherInsurance: string | null;
};

export const MoreOffersForm = () => {
  const { setFormInfo, formInfo } = useInsuranceForDoctorsFormType();

  const submitLeadAndTriggerMailMutation =
    trpcNoAuth['lead-management']['lead']['submit-lead-for-doctors'].useMutation();

  let storedFormInfo: MoreOffersFormInfo = {
    professionalIndemnityForDoctors: null,
    professionalIndemnityForMedicalSetup: null,
    motorInsurance: null,
    healthInsurance: null,
    homeInsurance: null,
    cyberInsurance: null,
    otherInsurance: null,

    selectedSpeciality: null,

    numberOfBeds: null,
    vehicleRegistrationNumber: null,

    typeOfHealth: null,
    sumInsured: null, //Health Sum Insured

    pincode: null,
    homeInsuranceSumInsured: null, //Home Sum Insured

    cyberInsuranceSumInsured: null, //Cyber Sum Insured

    typeOfOtherInsurance: null,
  };

  if (typeof window !== 'undefined') {
    const savedInfo = localStorage.getItem('moreOffersFormInfo');
    if (savedInfo) {
      storedFormInfo = JSON.parse(savedInfo);
    }
  }
  return (
    <Form
      initialValues={{
        professionalIndemnityForDoctors:
          storedFormInfo.professionalIndemnityForDoctors || formInfo.professionalIndemnityForDoctors || false,
        professionalIndemnityForMedicalSetup:
          storedFormInfo.professionalIndemnityForMedicalSetup || formInfo.professionalIndemnityForMedicalSetup || false,
        motorInsurance: storedFormInfo.motorInsurance || formInfo.motorInsurance || false,
        healthInsurance: storedFormInfo.healthInsurance || formInfo.healthInsurance || false,
        homeInsurance: storedFormInfo.homeInsurance || formInfo.homeInsurance || false,
        cyberInsurance: storedFormInfo.cyberInsurance || formInfo.cyberInsurance || false,
        otherInsurance: storedFormInfo.otherInsurance || formInfo.otherInsurance || false,

        selectedSpeciality: storedFormInfo.selectedSpeciality || formInfo.selectedSpeciality || null,

        numberOfBeds: storedFormInfo.numberOfBeds || formInfo.numberOfBeds || null,
        vehicleRegistrationNumber:
          storedFormInfo.vehicleRegistrationNumber || formInfo.vehicleRegistrationNumber || null,

        typeOfHealth: storedFormInfo.typeOfHealth || formInfo.typeOfHealth || false,
        sumInsured: storedFormInfo.sumInsured || formInfo.sumInsured || null, //Health Sum Insured

        pincode: storedFormInfo.pincode || formInfo.pincode || null,
        homeInsuranceSumInsured: storedFormInfo.homeInsuranceSumInsured || formInfo.homeInsuranceSumInsured || null, //Home Sum Insured

        cyberInsuranceSumInsured: storedFormInfo.cyberInsuranceSumInsured || formInfo.cyberInsuranceSumInsured || null, //Cyber Sum Insured

        typeOfOtherInsurance: storedFormInfo.typeOfOtherInsurance || formInfo.typeOfOtherInsurance || null,
      }}
      validationSchema={Yup.object().shape({
        professionalIndemnityForDoctors: Yup.boolean(),
        professionalIndemnityForMedicalSetup: Yup.boolean(),
        motorInsurance: Yup.boolean(),
        healthInsurance: Yup.boolean(),
        homeInsurance: Yup.boolean(),
        cyberInsurance: Yup.boolean(),
        otherInsurance: Yup.boolean(),

        // selectedSpeciality: Yup.string().required('Speciality is required').typeError('Speciality is required'),

        // numberOfBeds: Yup.number(),
        // vehicleRegistrationNumber: Yup.string().matches(
        //   regex.vehicleRegistrationNumber,
        //   'Invalid Vehicle Registration Number',
        // ),

        // typeOfHealth: Yup.boolean(),
        // sumInsured: Yup.number(),

        // pincode: Yup.number(),
        // homeInsuranceSumInsured: Yup.number(),
        // cyberInsuranceSumInsured :Yup.number(),

        // typeOfOtherInsurance: Yup.string(),
      })}
      onSubmit={async (values) => {
        console.log('values', values);

        localStorage.setItem('moreOffersFormInfo', JSON.stringify(values));

        setFormInfo({
          professionalIndemnityForDoctors: values.professionalIndemnityForDoctors,
          professionalIndemnityForMedicalSetup: values.professionalIndemnityForMedicalSetup,
          motorInsurance: values.motorInsurance,
          healthInsurance: values.healthInsurance,
          homeInsurance: values.homeInsurance,
          cyberInsurance: values.cyberInsurance,
          otherInsurance: values.otherInsurance,

          selectedSpeciality: values.selectedSpeciality,

          numberOfBeds: values.numberOfBeds ? Number(values.numberOfBeds) : null,
          vehicleRegistrationNumber: values.vehicleRegistrationNumber,

          typeOfHealth: values.typeOfHealth,
          sumInsured: values.sumInsured ? Number(values.sumInsured) : null,
          pincode: values.pincode ? Number(values.pincode) : null,
          homeInsuranceSumInsured: values.homeInsuranceSumInsured ? Number(values.homeInsuranceSumInsured) : null,
          cyberInsuranceSumInsured: values.cyberInsuranceSumInsured ? Number(values.cyberInsuranceSumInsured) : null,
          typeOfOtherInsurance: values.typeOfOtherInsurance,
        });

        await submitLeadAndTriggerMailMutation.mutateAsync({
          leadId: formInfo.leadId as number,
          professionalIndemnityForDoctors: values.professionalIndemnityForDoctors,
          professionalIndemnityForMedicalSetup: values.professionalIndemnityForMedicalSetup,
          motorInsurance: values.motorInsurance,
          healthInsurance: values.healthInsurance,
          homeInsurance: values.homeInsurance,
          cyberInsurance: values.cyberInsurance,
          otherInsurance: values.otherInsurance,
          selectedSpeciality: values.selectedSpeciality,
          numberOfBeds: values.numberOfBeds ? Number(values.numberOfBeds) : null,
          vehicleRegistrationNumber: values.vehicleRegistrationNumber,
          typeOfHealth: values.typeOfHealth,
          sumInsured: values.sumInsured ? Number(values.sumInsured) : null,
          pincode: values.pincode ? Number(values.pincode) : null,
          homeInsuranceSumInsured: values.homeInsuranceSumInsured ? Number(values.homeInsuranceSumInsured) : null,
          cyberInsuranceSumInsured: values.cyberInsuranceSumInsured ? Number(values.cyberInsuranceSumInsured) : null,
          typeOfOtherInsurance: values.typeOfOtherInsurance,
        });
        // showToast({
        //   title: 'Form successfully submitted!',
        //   variant: 'success',
        // });

        showToast({
          title: 'Thank You for Submitting the Complete Form!',
          description:
            'Your request has been submitted to a certified PrishaPolicy executive who will be reaching out to you soon.',
          variant: 'success',
        });
      }}
      className="grid rounded-lg bg-white px-5 pb-5"
    >
      <div className="scrollbar-hide grid max-h-[550px]  gap-3 overflow-auto ">
        <div className="text-title-6  font-bold">We have a few more interesting deals for you!</div>
        <div className="text-body-1">Kindly select all the products you are interested in. </div>
        <MoreOffersContextForm />
      </div>

      <div className="sticky bottom-0 mt-5 rounded-lg bg-white">
        <Button
          text="Submit Details"
          type="submit"
          className="w-full"
          disabled={submitLeadAndTriggerMailMutation.isPending}
        />
      </div>
    </Form>
  );
};

const MoreOffersContextForm = () => {
  const router = useRouter();
  const { productType } = router.query;
  const ctx = useFormikContext<{
    professionalIndemnityForDoctors: boolean | undefined;
    professionalIndemnityForMedicalSetup: boolean | undefined;
    motorInsurance: boolean | undefined;
    healthInsurance: boolean | undefined;
    homeInsurance: boolean | undefined;
    cyberInsurance: boolean | undefined;
    otherInsurance: boolean | undefined;

    // numberOfBeds: number | undefined;
    // vehicleRegistrationNumber: string | undefined;
    // typeOfHealth: boolean | undefined;
    // sumInsured: number | undefined;

    // pincode: number | undefined;
    // homeInsuranceSumInsured: number | undefined;

    // cyberInsuranceSumInsured : number | undefined;

    // typeOfOtherInsurance: string | undefined;
  }>();

  return (
    <div className="grid">
      {/* {productType !== 'professional-indemnity-for-doctors' && (
        <div className="border-grey-200 border-b p-4">
          <CheckToggle
            name="professionalIndemnityForDoctors"
            label={
              <div className="ml-3 flex items-center gap-4">
                <div className="rounded-lg bg-yellow-200 p-3">
                  <Image src={require('./professional.png')} alt={'professional'} className="h-5 w-5" />
                </div>
                <div className="">Professional Indemnity for doctors</div>
              </div>
            }
          />
        </div>
      )} */}

      <div className="border-grey-200 border-b p-4">
        <CheckToggle
          name="professionalIndemnityForDoctors"
          label={
            <div className="ml-3 flex items-center gap-4">
              <div className="rounded-lg bg-yellow-200 p-3">
                <Image src={require('./professional.png')} alt={'professional'} className="h-5 w-5" />
              </div>
              <div className="">Professional Indemnity for doctors</div>
            </div>
          }
        />

        {ctx.values.professionalIndemnityForDoctors && (
          <div className="mt-2 ml-10">
            <DropDownSelect
              name="selectedSpeciality"
              placeholder="Select Speciality"
              label="Speciality"
              showSearchBar={true}
              options={[
                {
                  options: OptionsArray.map((e) => ({
                    value: e,
                    mainText: e,
                  })),
                },
              ]}
            />
          </div>
        )}
      </div>

      {productType !== 'professional-indemnity-for-medical-setup' && (
        <div className="border-grey-200 border-b p-4">
          <CheckToggle
            name="professionalIndemnityForMedicalSetup"
            label={
              <div className="ml-3 flex items-center gap-4">
                <div className="rounded-lg bg-yellow-200 p-3">
                  <Image src={require('./professional.png')} alt={'professional'} className="h-5 w-5" />
                </div>
                <div className="">Professional Indemnity for medical set-up</div>
              </div>
            }
          />

          {ctx.values.professionalIndemnityForMedicalSetup && (
            <div className="mt-2 ml-10">
              <TextInput name="numberOfBeds" placeholder="Enter Number of beds" label="" />
            </div>
          )}
        </div>
      )}

      {productType !== 'cyber-insurance' && (
        <div className="border-grey-200 border-b p-4">
          <CheckToggle
            name="cyberInsurance"
            label={
              <div className="ml-3 flex items-center gap-4">
                <div className="rounded-lg bg-purple-100 p-3">
                  <Image src={require('./cyber-insurance.png')} alt={'cyber-insurance'} className="h-5 w-5" />
                </div>
                <div>Cyber Insurance</div>
              </div>
            }
          />

          {/* {ctx.values.cyberInsurance && (
            <div className="mt-2 ml-10">
              <TextInput name="cyberInsuranceSumInsured" placeholder="Enter Sum Insured" label="" />
            </div>
          )} */}
        </div>
      )}

      {productType !== 'motor-insurance' && (
        <div className="border-grey-200 border-b p-4">
          <CheckToggle
            name="motorInsurance"
            label={
              <div className="ml-3 flex items-center gap-4">
                <div className="rounded-lg bg-red-200 p-3">
                  <Image src={require('./motor-insurance.png')} alt={'motor-insurance'} className="h-5 w-5" />
                </div>
                <div>Motor Insurance</div>
              </div>
            }
          />

          {ctx.values.motorInsurance && (
            <div className="mt-2 ml-10">
              <TextInput name="vehicleRegistrationNumber" placeholder="Enter Vehicle Registration Number" label="" />
            </div>
          )}
        </div>
      )}

      {productType !== 'health-insurance' && (
        <div className="border-grey-200 border-b p-4">
          <CheckToggle
            name="healthInsurance"
            label={
              <div className="ml-3 flex items-center gap-4">
                <div className="rounded-lg bg-green-200 p-3">
                  <Image src={require('./health-insurance.png')} alt={'health-insurance'} className="h-5 w-5" />
                </div>
                <div>Health Insurance</div>
              </div>
            }
          />

          {ctx.values.healthInsurance && (
            <div className="mt-2 ml-10 grid gap-y-2">
              <BoxToggle
                name="typeOfHealth"
                options={[
                  {
                    displayName: 'Family',
                  },
                  {
                    displayName: 'Self',
                  },
                ]}
                className="w-full"
              />

              <TextInput name="sumInsured" placeholder="Enter Sum Insured" label="" />
            </div>
          )}
        </div>
      )}

      {productType !== 'home-insurance' && (
        <div className="border-grey-200 border-b p-4">
          <CheckToggle
            name="homeInsurance"
            label={
              <div className="ml-3 flex items-center gap-4">
                <div className="rounded-lg bg-teal-200 p-3">
                  <Image src={require('./home-insurance.png')} alt={'home-insurance'} className="h-5 w-5" />
                </div>
                <div>Home Insurance</div>
              </div>
            }
          />

          {ctx.values.homeInsurance && (
            <div className="mt-2 ml-10 grid gap-y-2">
              <TextInput name="pincode" placeholder="Enter Pincode" label="" />
              <TextInput name="homeInsuranceSumInsured" placeholder="Enter Sum Insured" label="" />
            </div>
          )}
        </div>
      )}

      <div className="border-grey-200 border-b p-4">
        <CheckToggle
          name="otherInsurance"
          label={
            <div className="ml-3 flex items-center gap-4">
              <div className="rounded-lg bg-blue-200 p-3">
                <Image src={require('./other-insurance.png')} alt={'other-insurance'} className="h-5 w-5" />
              </div>
              <div>Other Insurance</div>
            </div>
          }
        />

        {ctx.values.otherInsurance && (
          <div className="mt-2 ml-10">
            <TextInput name="typeOfOtherInsurance" placeholder="Enter Any other (Ex: Life)" label="" />
          </div>
        )}
      </div>
    </div>
  );
};
